import React, { useRef, useState } from 'react';
import { Text, Tooltip } from 'wt-ui';

const Units = ({ units, shortUnits }) => {
  const [over, setOver] = useState(false);
  const ref = useRef(null);
  return (
    <>
      <Text
        ref={ref}
        onMouseOver={() => setOver(true)}
        onMouseOut={() => setOver(false)}
        onFocus={() => {}}
        onBlur={() => {}}
      >
        {shortUnits}
      </Text>
      {ref.current && over && (
        <Tooltip align={{ bottom: 'top', left: 'left' }} target={ref.current} delay={400} width="300px">
          {units}
        </Tooltip>
      )}
    </>
  );
};

export default Units;
